import { createCastleAdapter } from "@func-core/core/data/adapters";
import { rollbar, RollbarLogArgument } from "@utils/rollbar";

export const initializeCastleService = async (): Promise<void> => {
  try {
    const adapter = createCastleAdapter();
    await adapter.initialize();
  } catch (error) {
    rollbar.error("Failed to initialize Castle", error as RollbarLogArgument);
  }
};
